/**
 * Request validation schemas.
 * Used for validating incoming HTTP requests.
 */
import { z } from "zod";
import { environmentSchema } from "./environment";
import { tenantIdSchema } from "./tenant";
/** Request context headers schema */
export const requestHeadersSchema = z.object({
    "x-tenant-id": tenantIdSchema,
    "x-environment": environmentSchema,
    "x-request-id": z.string().min(1).optional(),
});
/** JWT claims schema for auth */
export const jwtClaimsSchema = z.object({
    sub: z.string().min(1),
    iss: z.string().min(1),
    aud: z.union([z.string(), z.array(z.string())]),
    exp: z.number(),
    nbf: z.number().optional(),
    iat: z.number().optional(),
    tenantId: tenantIdSchema,
    environment: environmentSchema,
    roles: z.array(z.string()).default([]),
});
